export const PDF_DOCUMENT_ACCEPT = ".pdf,application/pdf";

export const AUDIT_DOCUMENT_ACCEPT = [
  PDF_DOCUMENT_ACCEPT,
  ".doc",
  "application/msword",
  ".docx",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
].join(",");

/** Flow 3 accepts the document formats shown in its upload prompts. */
export const isSupportedComposerFile = (
  file: Pick<File, "name" | "type">,
  allowOfficeDocuments = false,
): boolean => {
  const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
  if (isPdf) return true;
  if (!allowOfficeDocuments) return false;

  return (
    file.type === "application/msword" ||
    file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    /\.docx?$/i.test(file.name)
  );
};
